import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function Proof() {
  const niches = ['Fitness', 'Educación', 'Finanzas', 'Relaciones', 'Motivación', 'Superación Personal', '¡Y más!'];
  const results = ['Primer video IA en 45 minutos → 15K vistas en TikTok', 'Creando contenido de nuevo después de meses de burnout', 'Video viral = 43 ventas en una noche', 'Voces IA mejor que locutores reales'];
  return <section className="w-full px-4 py-16 md:py-20 bg-slate-900/30" data-id="element-293">
      <div className="max-w-5xl mx-auto" data-id="element-294">
        <div className="text-center mb-12" data-id="element-295">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-296">
            Resultados Reales. Usuarios Reales.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-297">
          {results.map((result, index) => <div key={index} className="bg-slate-800/40 border border-slate-700/50 rounded-xl p-6 hover:border-purple-500/50 transition-colors" data-id="element-298">
              <div className="flex items-start gap-3" data-id="element-299">
                <CheckCircle2Icon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-300" />
                <p className="text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-301">
                  {result}
                </p>
              </div>
            </div>)}
        </div>
        <div className="bg-slate-800/30 border border-slate-700/50 rounded-2xl p-6 md:p-10" data-id="element-302">
          <h3 className="text-xl md:text-3xl font-bold text-white text-center mb-8 leading-tight" data-id="element-303">
            Funciona en todos los nichos:
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-w-3xl mx-auto" data-id="element-304">
            {niches.map((niche, index) => {})}
          </div>
        </div>
      </div>
    </section>;
}